import { render } from "./ShorterLinkRedirectPage.vue?vue&type=template&id=fc0442dc"
import script from "./ShorterLinkRedirectPage.vue?vue&type=script&lang=js"
export * from "./ShorterLinkRedirectPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__